import { fsPath as outerBase } from '../__path';

export const fsPath = `${outerBase}/renderer`;
